import { render, staticRenderFns } from "./interTab.vue?vue&type=template&id=89b7d1d4&scoped=true"
import script from "./interTab.vue?vue&type=script&lang=js"
export * from "./interTab.vue?vue&type=script&lang=js"
import style0 from "./interTab.vue?vue&type=style&index=0&id=89b7d1d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b7d1d4",
  null
  
)

export default component.exports